// extracted by mini-css-extract-plugin
export var columns1 = "TileLayout-module--columns1--eda37";
export var columns2 = "TileLayout-module--columns2--6550b";
export var columns3 = "TileLayout-module--columns3--67c6d";
export var columns4 = "TileLayout-module--columns4--4dbad";
export var tile = "TileLayout-module--tile--d3da5";
export var tiles = "TileLayout-module--tiles--5dff8";